// import { sanitize } from 'dompurify';
import React from 'react';
import styled from 'styled-components';
import { Heading3, spacing, TextParagraph } from '../../theme';
import colors from '../../theme/variables/colors';
import WarningIcon from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-alert-warning.svg'
import { AddressType, FormSectionElements, FormSections, FormSubSections, ProgramContainer, SummaryStyleType } from '../../entities/formTemplateDataType';
import PasswordShowButtonCompnent from './PasswordShowButtonCompnent';
import PasswordHideButtonCompnent from './PasswordHideButtonCompnent';
import DataUtils from '../../utilities/DataUtils';
import { Address } from '../../runtimeComponent/subComponent/AddressSearchComponent';
import { getAddress } from '../../utilities/addressUtils';
import { getRootComponent, getSubSectionButton } from '../../utilities/ElementUtils';
import { ReactComponent as EditIcon } from "../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-edit.svg";
const Text = styled(TextParagraph)`
    margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing3} ${spacing.spacing0};
`;

const InfoElementContainer = styled.div`
    border-bottom: ${props => (props.className?.includes('notBordered') ? '0px' : '1px')} solid
        ${colors.palette.greyscale5};
    margin-top: ${spacing.spacing5};
    min-width: 253.33px;
`;

const Headline = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const SplitRight = styled.div`
    width: 100%;
    display: flex;
    justify-content: ${props => (props.className === 'start' ? 'start' : 'space-between')};
`;
const Icon24Container = styled.div`
    display: flex;
    svg {
        height: 24px;
        width: 24px;
    }
`;
const StyledHeading = styled(Heading3)`
    display: flex;
    align-items: center;
    gap: ${spacing.spacing2};
`;


interface Props {
    field: FormSectionElements;
    isEng: boolean;
    withButton: boolean;
    style?: SummaryStyleType;
    handleEditButtonClick?: (field: FormSectionElements) => void;
    callback: (programContainer: ProgramContainer) => void;
    children?: React.ReactNode;
}


export class InfoElementComponent extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        
        this.props.field.mask=true;
    }

    profile = this.props.field.parent.parent.parent.Profile;

    findAddressElement = (summaryField: FormSectionElements) => {
        const root = getRootComponent(summaryField);
        let addressField: FormSectionElements;
        let find = false;
        
        for (const form of root.ListOfFormSections) {
            if (find) break;
            for (const subForm of form.ListOfFormSubSections) {
                const fields = subForm.ListOfFormSectionElements.filter(ele => (
                    ele.Datatype==='Address' && (ele.addressType ?? 'Residential') === (summaryField.addressType ?? 'Residential')
                ));

                if (fields.length) {
                    addressField = fields[0];
                    find = true;
                    break;
                }
            }
        }
        return addressField;
    }

    splitAddress=(wholeAddress?: Address): string => {
        if (!wholeAddress) return '';
        const address = getAddress(wholeAddress, this.props.field.mask, this.props.isEng ? 'en' : 'fr');
        // console.log(`masked address: ${address}`);
        return address;
    }

    splitAddressFromField = (summaryField: FormSectionElements) => {
        const addressField = this.findAddressElement(summaryField);
        if (addressField) {
            return this.splitAddress(addressField.Address)
        }
        return '';
    }
    
    sanitize(input) {
        return input ? input.replace(/<[^>]*>?/gm, '') : ''; // Removes HTML tags
    }
    render() {
        const field = this.props.field;
        const isEng = this.props.isEng;
        const label = isEng ? field.ENUTitle : field.FRATitle;
        let value;
        if (field.MaskInSummary) {
            switch (field.Datatype) {
                case "ODSDate":
                    value = field.mask ? "****/**/**" : field.Value;
                    break;
                case "Address":
                    // value= this.splitAddress((field.Address || this.profile?.address) as Address | undefined)
                    value = this.splitAddressFromField(field)
                    break;
                case "Email":
                const emailParts = field.Value?.split('@');
                let maskedValue = emailParts[0].substring(0, 2) + '******';
                if (emailParts.length > 1) {
                    const emailDomainParts = emailParts[1].split('.');
                    maskedValue += `@${emailDomainParts[0].substring(0, 1)}*****`;
                    if (emailDomainParts.length > 1) {
                        maskedValue += `.${emailDomainParts[1]}`;
                    }
                }
                value = field.mask? maskedValue:field.Value;
            break;
                default:
                    const len = field.Value?.length;
                    if (len > 3) {
                        const maskLength = len - 3;
                        value = field.mask ? DataUtils.maskString(field.Value, 0, maskLength) : field.Value;
                    }
            }
        } else {
            value = field.Value;
        }
      
        //const value = field.mask ? DataUtils.maskString(field.Value, 0, 3) : field.Value;
        return (
            <>
                <InfoElementContainer className={`info-element notBordered`}>
                    <Headline>
                        <StyledHeading styledAs="h4">
                            {label}
                            {/* {!field.Valid && (
                                <Icon24Container>
                                    <WarningIcon />
                                </Icon24Container>
                            )} */}
                        </StyledHeading>
                        {(this.props.style === 'Link' || this.props.style === 'All') && (
                            <button style={{display: 'flex', alignItems: 'start', border: 'none', backgroundColor: '#fff', cursor: 'pointer', textDecoration: 'underline', padding: '0.25rem 0'}} 
                                title={this.props.isEng ? "Edit" : "Modifier"}
                                onClick={() => {
                                    const subSectionButton = getSubSectionButton(field.parent as FormSubSections);
                                    this.props.handleEditButtonClick(subSectionButton)
                                }}
                            >
                                <EditIcon aria-hidden='true' fill='#00478f'/>
                                <span style={{color: "#00478f", fontSize: "1.2rem"}}>{this.props.isEng ? "Change" : "Modifier"}</span>
                            </button>
                        )}
                    </Headline>
                    <SplitRight id="infoelementsplit">
                        <Text
                            dangerouslySetInnerHTML={{
                                __html: this.sanitize(value),
                            }}
                        />{' '}
                        {this.props.withButton && field.MaskInSummary ?
                            field.mask
                                ? <PasswordShowButtonCompnent field={field} callback={(programContainer) => {
                                    this.props.callback(programContainer);
                                }} />
                                : <PasswordHideButtonCompnent field={field} callback={(programContainer) => {
                                     this.props.callback(programContainer);
                                }} /> : null}

                    </SplitRight>
                    {this.props.children}
                </InfoElementContainer>
            </>
        )
    }
}
